import { QRCode } from "jsqr"
import React from "react"
import BackButton from "../../../../components/Tablet/BackButton"
import { CSS_PROPERTY } from "../../cssProperties/tablet"
import { AppDispatch } from "../../../.."
import { useHistory } from "react-router-dom"
import { useDispatch } from "react-redux"
import { clearAlert, setAlerts } from "../../../../globalStore/alertStore"
import { selectModePage } from "../../../../constant/tablet/pages"
import ScanQRCodeComponent from "../../../../components/ScanQRCodeComponent"
import { tenkosyaLoginByQRCode } from "../../../../globalStore/authStore"

const LoginByQRCode = React.memo(() => {
  const history = useHistory()
  const dispatch: AppDispatch = useDispatch()

  const loginFunc = async (code: QRCode) => {
    dispatch(clearAlert())
    try {
      const res = await dispatch(tenkosyaLoginByQRCode({ QRコード: code.data }))
      if (res) {
        //

        history.push(selectModePage.Route.path)
      }
    } catch (error) {
      dispatch(setAlerts(error))
    }
  }

  return (
    <>
      <table
        style={{ tableLayout: "fixed", height: "100%" }}
        className="w-100 mt-3">
        <tbody>
          <tr>
            <td colSpan={2}>QRコードを読み取らせてください</td>
          </tr>
          <tr>
            <td
              colSpan={2}
              style={{
                height: "35rem",
                textAlign: "center",
              }}>
              <div className="d-inline-block">
                <ScanQRCodeComponent
                  width="auto"
                  height="35rem"
                  readAfterFunction={loginFunc}></ScanQRCodeComponent>
              </div>
            </td>
          </tr>
          <tr>
            <td
              className="align-bottom"
              style={{ height: CSS_PROPERTY.BODY_TABLE_BUTTON_ROW_HEIGHT }}>
              <BackButton />
            </td>
            <td className="text-end"></td>
          </tr>
        </tbody>
      </table>
    </>
  )
})

export default LoginByQRCode
